<div class="grid">
  <div class="col-12">
    <span class="section-title mt-3" translate>payment_detail_processing_rules_label</span>
  </div>
  <div class="col-2">
    <label>{{ 'payment_detail_full_credit_label' | translate }}:</label><br>
    <span class="field-value" translate>{{ processingRules.fullCredit ? 'common_yes' : 'common_no' }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_invoice_required_label' | translate }}:</label><br>
    <span class="field-value" translate>{{ processingRules.invoiceRequired ? 'common_yes' : 'common_no' }}</span>
  </div>
  <div class="col-4 text-overflow">
    <label>{{ 'payment_detail_authorized_charges_label' | translate }}:</label><br>
    <span class="field-value">{{ processingRules.authorizedCharges }}</span>
  </div>
  <div class="col-3">
    <label>{{ 'payment_detail_restrictions_label' | translate }}:</label><br>
    <span class="field-value">{{ processingRules.restrictions }}</span>
  </div>
</div>